import React, {Component} from 'react';
import {createHistory} from 'react-router'
import './style.scss';
import {API} from '@/api';
import {Row, Col, message, Popover, Avatar, Icon, Layout, Select, Input, Affix} from 'antd';

export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      link: {},
      isLoading: false
    }
  }

  componentDidUpdate() {
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    API.friendLink({}).then((response) => {
      const {data, code, msg, time} = response;
      if (code === 1) {
        this.setState({
          isLoading: true,
          link: data
        })
      } else {
        message.error(msg);
      }
    });
  }

  render() {
    const {isLoading, link} = this.state
    let tpl = []
    for (let i = 0; i < link.length; i++) {
      tpl.push(
        <>
          <a href={link[i].url} target="_blank">{link[i].name}</a>
          {i < link.length - 1 ? ' | ' : ''}
        </>
      )
    }

    return (
      isLoading ?
        <div className="g-footer bg-white">
          <div className="footer-con">
            <div className="inner-link">
              {tpl}
            </div>
            <Row align="middle">
              <Col span={18}>
                <div className="copyrights">Copyright © 2020 mixs.cn, All Rights Reserved. <a target="_blank"
                                                                                              href="#">蜜阅书苑</a>版权所有
                  未经书面许可不得复制转载。
                  <div> 浙公安机关备案33010602000912号 电信增值业务许可证：浙B2-20160439 <a href="http://www.beian.miit.gov.cn/"
                                                                         target="_blank">浙ICP备12033801号-4</a> <br/>请所有作者发布作品时务必遵守国家互联网信息管理办法规定，我们拒绝任何违规小说，一经发现，即作删除！<br/>办公地址：杭州市西湖区绿城西溪世纪中心2-619
                    联系电话 0571-86025512</div>
                </div>
                <div className="safe-img-con">
                  <a href="http://www.12377.cn" target="_blank">
                    <div className="safe-img1"></div>
                  </a>
                  <a href="http://www.shjbzx.cn" target="_blank">
                    <div className="safe-img2"></div>
                  </a>
                  <a
                    href="https://ss.knet.cn/verifyseal.dll?sn=e17122933010071243aa8b000000&ct=df&a=1&pa=0.014416504272526387"
                    target="_blank">
                    <div className="safe-img3"></div>
                  </a>

                </div>
              </Col>
              <Col span={6}>
              </Col>
            </Row>
          </div>
        </div>
        : ''
    )
  }
}
